import { render } from "./CenterBox.vue?vue&type=template&id=8bf01a42&scoped=true"
import script from "./CenterBox.vue?vue&type=script&lang=js"
export * from "./CenterBox.vue?vue&type=script&lang=js"

import "./CenterBox.vue?vue&type=style&index=0&id=8bf01a42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8bf01a42"

export default script